import React, { useEffect, useState } from "react";
// primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
// context
import { useContextSimulator } from "../../SimulatorContext";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format, parseISO } from "date-fns";

const ConstructionInstallments = () => {
  const {
    minConstructionValue,
    simulatorData,
    firstConstructionParcelDate, setFirstConstructionParcelDate,
    othersConstructionParcelDate, setOthersConstructionParcelDate,
    selectedConstructionTerm, setSelectedConstructionTerm,
    setConstructionParcelsTable,
    selectedPricingTable,
    calculatePricePayment,
    generateInstallments,
    setConstructionTotalValue,
    setConstructionFinalValue,
    setConstructionInterest,
    calculateSimpleInterestPayment
  } = useContextSimulator();

  const [constructionShowTable, setConstructionShowTable] = useState(null);

  useEffect(() => {
    if (simulatorData && selectedConstructionTerm && firstConstructionParcelDate && minConstructionValue) {
      handleConstructionData();
    }

    if (simulatorData.construction_payments_enable) {
      setConstructionFinalValue(minConstructionValue);
    }
  }, [selectedConstructionTerm, firstConstructionParcelDate, othersConstructionParcelDate, selectedPricingTable]);

  const fetchConstructionValues = async () => {
    let installments;
    const currentTax = simulatorData.construction_payments_rate_interest / 100;

    const constructionPriceTable = simulatorData.amortization_system.find(e => e.type === "construction");
    if (constructionPriceTable !== undefined) {
      await calculatePricePayment(
        minConstructionValue,
        currentTax,
        selectedConstructionTerm
      ).then((res) => {
        installments = res;
      });
    } else {
      await calculateSimpleInterestPayment(
        minConstructionValue,
        currentTax,
        selectedConstructionTerm
      ).then((res) => {
        installments = res;
      });
    }

    // switch (selectedPricingTable) {
    //   case "price":
    //     await calculatePricePayment(
    //       minConstructionValue,
    //       currentTax,
    //       selectedConstructionTerm
    //     ).then((res) => {
    //       installments = res;
//       console.log("Price Construction: ", res);
    //     });
    //     break;
    //   case "sac":
    //     await calculateSACPayments(
    //       minConstructionValue,
    //       currentTax,
    //       selectedConstructionTerm
    //     ).then((res) => {
    //       installments = res;
//       console.log("SAC Construction: ", res);
    //     });
    //     break;
    //   case "sac_inverso":
    //     await calculateInverseSACPayments(
    //       minConstructionValue,
    //       currentTax,
    //       selectedConstructionTerm
    //     ).then((res) => {
    //       installments = res;
//       console.log("Sac Inverso Construction: ", res);
    //     });
    //     break;
    //   case "sacre":
//     console.log("Sacre");
    //     break;
    //   case "sacre_ib":
//     console.log("Sacre IB");
    //     break;
    //   case "sacoc":
//     console.log("SACOC");
    //     break;
    //   case "interest_free":
//     console.log("Sem Juros");
    //     await calculateInterestFreePayments(
    //       minConstructionValue,
    //       selectedConstructionTerm
    //     ).then((res) => {
    //       installments = res;
    //     });
    //     break;
    //   default:
    //     break;
    // }
    
    return installments;
  };

  const handleConstructionData = async () => {
    let constructionTable = null;
    const constructionPricingTable = await fetchConstructionValues();
//    console.log("constructionPricingTable: ", constructionPricingTable);
//    console.log("firstConstructionParcelDate: ", firstConstructionParcelDate);
//    console.log("othersConstructionParcelDate: ", othersConstructionParcelDate);

    if (constructionPricingTable && constructionPricingTable.payments) {
      setConstructionTotalValue(parseFloat(minConstructionValue) + parseFloat(constructionPricingTable.totalInterest));
      constructionTable = await generateInstallments(constructionPricingTable.payments, firstConstructionParcelDate, othersConstructionParcelDate);
    }

//    console.log("Table: ", constructionTable);

    const table = constructionTable.map(c => ({
      value: formatCurrency(c.value),
      due_date: format(parseISO(c.due_date), "dd/MM/yyyy"),
      sequence_number: c.sequence_number,
    }));
    setConstructionShowTable(table);
    setConstructionInterest(parseFloat(constructionPricingTable.totalInterest));
    setConstructionParcelsTable(constructionTable);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-md-6 me-2 pb-2">
          <label className="mb-3">Parcela de Construção</label>
          <p className="input">{formatCurrency(minConstructionValue)}</p>
        </div>
        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Quantidade de Parcelas</label>
          <InputNumber 
          value={selectedConstructionTerm} 
          onValueChange={(e) => setSelectedConstructionTerm(e.value)} 
          showButtons buttonLayout="horizontal" step={1}
            max={simulatorData.construction_payments_max ? simulatorData.construction_payments_max : 0} min={0}
            decrementButtonClassName="p-button-danger" incrementButtonClassName="p-button-success" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
        </div>
        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Data Primeira Parcela</label>
          <Calendar
            value={firstConstructionParcelDate}
            onChange={(e) => setFirstConstructionParcelDate(e.value)}
            dateFormat={"dd/mm/yy"}
              mask="99/99/9999"
            className="w-100"
            locale="pt"
            minDate={new Date()}
          />
        </div>
        {selectedConstructionTerm > 1 && (
          <div className="col-md-3 pb-2">
            <label className="mb-3">Data Parcelamentos</label>
            <Calendar
              value={othersConstructionParcelDate}
              onChange={(e) => setOthersConstructionParcelDate(e.value)}
              dateFormat={"dd/mm/yy"}
              mask="99/99/9999"
              className="w-100"
              locale="pt"
              minDate={firstConstructionParcelDate}
            />
          </div>
        )}
      </div>
      {constructionShowTable && (
        <div className="row pt-4">
          <DataTable value={constructionShowTable} size={"normal"}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25]}>
            <Column field="sequence_number" header="Parcela"></Column>
            <Column field="value" header="Valor"></Column>
            <Column field="due_date" header="Data Pagamento"></Column>
            {/* <Column field="interest" header="Juros"></Column> */}
          </DataTable>
        </div>
      )}
    </>
  );
};

export default ConstructionInstallments;
